import { useContext } from 'react';
import { Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppProvider';
import { FLOW_TYPE } from 'consts';

export function RiskqTextBottom() {
	const { flowType, t } = useContext(AppContext);
	return FLOW_TYPE.RR_SU !== flowType ? null : (
		<Typography TagName="p" className="mt-5 mb-4">
			{t('rr-su_riskq_text_bottom', 'riskq')}
		</Typography>
	);
}
